import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUiVersion } from 'hooks';
import { SimpleSelect } from '../simple-select/simple-select';
import { FormatSelectV2 } from './format-select.v2';
import { themes, Button } from '../buttons';
import { Content, FormatPlace } from './export-button.styled';

const types = ['xls', 'csv'];

export const ExportButton = ({ children, getReport }) => {
  const { t } = useTranslation();
  const { isNew } = useUiVersion();
  const [format, setFormat] = useState(types[0]);

  /**
   * get format options
   */
  const getFormatOptions = () => {
    return types.map((el, idx) => {
      return (
        <option key={idx} value={el}>
          {el.toUpperCase()}
        </option>
      );
    });
  };

  /**
   * get file with format
   * @returns
   */
  const getFile = () => {
    return getReport(format);
  };

  /**
   * change format
   * @param {*} event
   */
  const changeFormat = (event) => {
    setFormat(event.target.value);
  };

  const formatOptions = getFormatOptions();

  return (
    <Content>
      <FormatPlace>
        {isNew ? (
          <FormatSelectV2 value={format} options={types} onChange={setFormat} />
        ) : (
          <SimpleSelect name="report_format" width="70px" value={format} onChange={changeFormat}>
            {formatOptions}
          </SimpleSelect>
        )}
      </FormatPlace>
      <Button theme={themes.blue} onClick={getFile}>
        <img src="/images/file-export.svg" alt="" style={{ width: '17px', height: '17px' }} />
        {children ? children : t('grid.getreport')}
      </Button>
    </Content>
  );
};
